import { createStyles, Grid, TextField, Theme, withStyles, WithStyles } from '@material-ui/core'
import React from 'react'

interface BenefitsProvidedProps extends WithStyles<typeof styles> {
	benefitsProvided: string
	onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

const BenefitsProvided: React.FC<BenefitsProvidedProps> = (props: BenefitsProvidedProps) => {
	const { classes, benefitsProvided, onChange } = props

	return (
		<Grid container={true} spacing={8}>
			<Grid item={true} xs={12} md={3} className={classes.dropdownLabel}>
				Benefits Provided&#58;
			</Grid>
			<Grid item={true} xs={12} sm={4} md={3} className={classes.dropdownLabel}>
				<TextField
					name="benefitsProvided"
					select={true}
					className={classes.dropdown}
					required={false}
					value={benefitsProvided}
					onChange={onChange}
					SelectProps={{
						native: true,
						MenuProps: {
							className: classes.select,
						},
					}}
					margin="dense"
					variant="outlined"
				>
					<option value="">Unknown</option>
					{['Yes', 'No'].map((option: string) => (
						<option key={option} value={option}>
							{option}
						</option>
					))}
				</TextField>
			</Grid>
		</Grid>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		dropdownLabel: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			paddingTop: '12px',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'flex-start',
			},
		},
		dropdown: {
			display: 'flex',
			flex: 1,
		},
		input: {},
		select: {
			textOverflow: 'ellipsis',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
		},
	})

export default withStyles(styles)(BenefitsProvided)
